import { render, staticRenderFns } from "./FrontProductItem.vue?vue&type=template&id=22bc3d8e&scoped=true&"
import script from "./FrontProductItem.vue?vue&type=script&lang=js&"
export * from "./FrontProductItem.vue?vue&type=script&lang=js&"
import style0 from "./FrontProductItem.vue?vue&type=style&index=0&id=22bc3d8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc3d8e",
  null
  
)

export default component.exports